import {defineStore} from "pinia";
import {NewFLowStep} from "~/models/enums";
import parseJwt from "~/utils/functions/parse-jwt";
import {AUTHENTICATION} from "~/utils/constants/localStorageKey";
import navigateAfterLogin from "~/utils/functions/navigate-after-login";
import type {FusionSharedDtosAccountSignInResponseDto} from "~/types/api/api";
import {zeblineLogin} from "~/utils/functions/zebline-method";

export const useAuthStore = defineStore("AuthStore", () => {
  const role = ref<string>("");
  const userId = ref<string>("");
  const userName = ref<string>("");
  const runtimeConfig = useRuntimeConfig();
  const isAlreadyFetchingAccessToken = ref<boolean>(false);

  const login = (loginResponse: FusionSharedDtosAccountSignInResponseDto, redirectUrl = '') => {

    setToken(loginResponse.accessToken || "", loginResponse.expiresIn || 0)
    // setRefreshToken(loginResponse.refreshToken || "")

    parseToken(loginResponse.accessToken || "")
    zeblineLogin(userName.value)

    if(!!loginResponse.redirectUrl){
      window.location.href = loginResponse.redirectUrl
    } else if (redirectUrl) {
      window.location.href = `${runtimeConfig.public.Redirect}${redirectUrl}`;
    } else if (loginResponse.canSeeNewFlow) {
      navigateAfterLogin(loginResponse.lastStep || NewFLowStep.Introduction);
    } else {
      navigateAfterLogin(NewFLowStep.Dashboard);
    }
  };

  const parseToken = (token: string) => {
    const parsToken = parseJwt(token);
    if (parsToken) {
      role.value = parsToken.role;
      userId.value = parsToken.nameid;
      userName.value = parsToken.unique_name;
    }
  }

  const getToken = () => {
    const accessCookie = useCookie(AUTHENTICATION.ACCESS_TOKEN, {
      watch: true,
    });
    return accessCookie.value;
  };

  const getRefreshToken = () => {
    const refreshCookie = useCookie(AUTHENTICATION.REFRESH_TOKEN, {
      watch: true,
    });
    return refreshCookie.value;
  };

  const setToken = (access: string, accessExp: number) => {
    localStorage.setItem(AUTHENTICATION.ACCESS_TOKEN, access);
    const accessCookie = useCookie(AUTHENTICATION.ACCESS_TOKEN, {
      maxAge: accessExp,
      sameSite: "strict",
      secure: true,
    });
    accessCookie.value = access
  };

  const setRefreshToken = (refresh: string, refreshExp: number = 0) => {
    const refreshCookie = useCookie(AUTHENTICATION.REFRESH_TOKEN, {
      maxAge: refreshExp,
      sameSite: "strict",
      secure: true,
    });
    refreshCookie.value = refresh

    localStorage.setItem(AUTHENTICATION.REFRESH_TOKEN, refresh);
  }

  const logout = () => {
    localStorage.removeItem(AUTHENTICATION.ACCESS_TOKEN);
    localStorage.removeItem(AUTHENTICATION.REFRESH_TOKEN);
    const accessCookie = useCookie(AUTHENTICATION.ACCESS_TOKEN);
    const refreshCookie = useCookie(AUTHENTICATION.REFRESH_TOKEN);

    accessCookie.value = null;
    refreshCookie.value = null;
  }

  return {
    role,
    userId,
    userName,
    isAlreadyFetchingAccessToken,
    login,
    logout,
    getToken,
    setToken,
    parseToken,
    setRefreshToken,
    getRefreshToken,
  };
});
